const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const REVIEW_FIELDS = [
  {
    id: "source_id",
    label: "Source",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 6,
    isRequired: true,
  },
  {
    id: "date",
    label: "Date",
    placeHolder: "Select",
    type: "date",
    md: 6,
    disablePast: true,
    isRequired: true,
  },
  {
    id: "title",
    label: "Review",
    placeHolder: "Enter Title",
    type: "text",
    md: 6,
    // isRequired: true,
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "job_id",
    label: "Service",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 6,
    isRequired: true,
  },
  {
    id: "rating_title",
    label: "Rating",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unrated",
      "Excellent",
      "Good",
      "Average",
      "Poor",
      "Very Poor",
      "Complaint",
    ],
    md: 4,
    isRequired: true,
  },
  {
    id: "obtained_from",
    label: "How Obtained",
    placeHolder: "Select",
    type: "select",
    options: ["Web", "App", "Spoken", "Customer Portal"],
    md: 4,
    isRequired: true,
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "Select",
    type: "select",
    options: [
      "Very Positive",
      "Positive",
      "General",
      "Negative",
      "Very Negative",
      "Complaint",
    ],
    md: 4,
    isRequired: true,
  },
  {
    id: "description",
    label: "Full Details",
    placeHolder: "Enter Full Details",
    type: "text",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "link",
    label: "Link",
    placeHolder: "Enter Link",
    type: "text",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
  },
];

export const validateReviewForm = (formData: any, fields: any[]) => {
  let errors: any = {};

  fields.forEach((field) => {
    if (field.isRequired) {
      const value = formData[field.id];

      // special case job_id OR job_name
      if (field.id === "job_id") {
        if (!formData?.job_id && !formData?.job_name) {
          errors["job_id"] = true;
        }
      } else if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        errors[field.id] = true;
      }
    }
  });

  return errors;
};
